import axios from "axios";
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import DetailsForm from "./AdForm/DetailsForm";
import VerificationCodeForm from "./AdForm/VerificationCodeForm";
const showAdIn = ["TX", "CA", "KY"];
const rates = [1, 2, 3, 4, 5];

export default function AdForm({ a }) {
	const { t, i18n } = useTranslation();
	const [ad, setAd] = useState({
		business_name: t("WERE_YOU_INJURED_"),
		call_to_action: t("FREE_LEGAL_CONSULTATION"),
		tagline1: t("YOU_MAY_BE_ENTITLED_TO_COMPENSATION"),
		image_url: "/assets/icon-hammer.svg",
		user: ""
	});

	const [currentStep, setCurrentStep] = useState(1);
	const [tcpaMessage, setTcpaMessage] = useState("");
	const [userData, setUserData] = useState();
	const [ajax, setAjax] = useState(true);
	const [submitted, setSubmitted] = useState(false);

	useEffect(() => {
		if (showAdIn.includes(a.state)) {
			axios
				.get(
					`/banner/30-miles-radius?lat=${a.location_lat}&lng=${a.location_lng}`
				)
				.then((d) => {
					if (d.data?.ad) setAd(d.data.ad);
					setAjax(false);
				})
				.catch(() => setAjax(false));
		} else {
			setAjax(false);
		}
	}, []);

	const submit = () => {
		setAjax(true);

		const headers = {
			"page-referrers": window.location.href
		};

		const { state } = userData;
		const data = {
			...userData,
			injured: false,
			fault: false,
			agree: false,
			accidentURL: window.location.href,
			businessReportURL: null,
			user: ad.user || "",
			state: state ?? a.state,
			language: i18n.language,
			trusted_form_cert: window.cert?.xxTrustedFormCertUrl || "",
			gclidcrm: window.gclidcrm || ""
		};

		axios
			.post("/contact/attorney", data, { headers })
			.then(() => {
				setAjax(false);
				setSubmitted(true);
			})
			.catch(() => {
				alert("Error submitting your form.");
				setAjax(false);
			});

		gtag("event", "Ad Form Fill", {
			event_category: "advertisement",
			event_label: "inline ad"
		});

		gtag("event", "CALawyer HOT", {
			event_category: "advertisement",
			event_label: "CALawyer HOT"
		});
	};
	if (submitted)
		return (
			<div className="ad-form">
				<div className="card-form">
					<h1>Thank you!</h1>
					<p>
						<span>Your form has been submitted.</span> Someone will contact you
						shortly.
					</p>
				</div>
			</div>
		);

	const onNextStep = async (data = {}) => {
		const { currentStep, tcpaMessage, ...restData } = data;
		setTcpaMessage(tcpaMessage);
		setUserData({ ...restData });
		setCurrentStep(currentStep);
	};

	return (
		<div className={ajax ? "ad-form ajax" : "ad-form"}>
			{t("ADVERTISEMENT")}
			<div className="card-form">
				<img
					src={ad.image_url}
					alt={ad.business_name}
					className="company-logo"
				/>
				<h1 data-testid="h1">{ad.business_name}</h1>
				{ad.user ? (
					<>
						<div className="rating">
							{ad.rating}
							{rates.map((v) => (
								<img
									key={v}
									alt={v}
									src={
										v <= Math.round(ad.rating)
											? "/assets/star.png"
											: "/assets/star-empty.png"
									}
								/>
							))}
						</div>
						<img src="/assets/google-reviews.png" width="70" />
					</>
				) : null}
				<p>
					<span className="ad-form-text">{ad.call_to_action}</span>
					{ad.tagline1}
					{ad.tagline2 ? <br /> : null}
					{ad.tagline2}
					<br />
					<span
						style={{ marginTop: 5, color: "var(--orange)", fontWeight: "bold" }}
					>
						{ad.phone}
					</span>
				</p>

				{currentStep === 2 ? (
					<VerificationCodeForm
						phone={userData?.phone}
						onSubmit={submit}
						tcpaMessage={tcpaMessage}
					/>
				) : (
					<DetailsForm
						onSubmit={onNextStep}
						advertisement={ad}
						accidentState={a?.state}
					/>
				)}
			</div>

			<a
				href="https://myaccident.org/request-free-legal-consultation"
				target="_blank"
				style={{ textAlign: "center" }}
			>
				{t("WHEN_SHOULD_I_REQUEST_LEGAL_CONSULTATION_")}
			</a>
		</div>
	);
}


